export function isEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function isPhone(phone) {
    const re = /^((([0]{2}\s?421\s*)|(0))?([0-9]\s*){9})$/
    return re.test(phone);
}



// WEBPACK FOOTER //
// ./src/helpers/validation.js